import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import CustomQuantitySelect from '../CustomQuantitySelect';
import FormattedPrice from '../Utilities/FormattedPrice';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { usePaymentFormContext } from '../../context/PaymentFormContext';
import { CPQ_PRODUCTS_TIERS_ALPHA_GATE } from '../../constants/gates';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function LineItemUnitPrice({
  id,
  currencyCode,
  price,
  pricing,
  effectiveUnitPrice,
  quantity,
  quantityMax,
  quantityMin,
  isEditable,
  error,
  selected,
  toggleSelected
}) {
  var _checkoutSession$get;
  const {
    checkoutSession
  } = usePaymentFormContext();
  const isUngatedToTieredPricing = (_checkoutSession$get = checkoutSession.get('gates')) === null || _checkoutSession$get === void 0 ? void 0 : _checkoutSession$get.includes(CPQ_PRODUCTS_TIERS_ALPHA_GATE);
  const Quantity = useCallback(() => isEditable ? /*#__PURE__*/_jsx(CustomQuantitySelect, {
    quantity: quantity,
    id: id,
    min: quantityMin,
    max: quantityMax,
    error: error,
    selected: selected,
    toggleSelected: toggleSelected
  }) : /*#__PURE__*/_jsxs(Text, {
    "data-test-id": "line-item-quantity",
    color: "text-core-subtle",
    typography: "body-125",
    children: ["\xD7", quantity]
  }), [isEditable, quantity, quantityMin, quantityMax, error, selected, toggleSelected, id]);
  return /*#__PURE__*/_jsx(Flex, {
    display: "flex",
    gap: "100",
    alignItems: "center",
    children: isUngatedToTieredPricing ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Quantity, {}), /*#__PURE__*/_jsx(Text, {
        as: "small",
        color: "text-core-subtle",
        "data-test-id": "line-item-tiered-unit-price",
        children: /*#__PURE__*/_jsx(TieredPricing, {
          quantity: quantity,
          effectiveUnitPrice: effectiveUnitPrice,
          pricing: pricing,
          currencyCode: currencyCode,
          price: price
        })
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "small",
        color: "text-core-subtle",
        "data-test-id": "line-item-unit-price",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "payments.perItem_jsx",
          options: {
            priceProps: {
              currencyCode,
              price
            }
          },
          elements: {
            FormattedPrice
          }
        })
      }), ' ', /*#__PURE__*/_jsx(Quantity, {})]
    })
  });
}
function TieredPricing({
  effectiveUnitPrice,
  pricing,
  currencyCode,
  price,
  quantity
}) {
  var _pricing$tierRanges$;
  // check if quantity is greater than first tier then we dont display the unit
  const quantityGreaterThanFirstTier = quantity > ((_pricing$tierRanges$ = pricing.tierRanges[0]) === null || _pricing$tierRanges$ === void 0 ? void 0 : _pricing$tierRanges$.end);
  switch (pricing.pricingModel) {
    // flat pricing is the standard one set price for all quantities
    case 'flat':
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "payments.perItem_jsx",
        options: {
          priceProps: {
            currencyCode,
            price
          }
        },
        elements: {
          FormattedPrice
        }
      });
    // volume pricing: the price decreases as the quantity increases, and all quantities have the same price
    case 'volume':
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "payments.perItem_jsx",
        options: {
          priceProps: {
            currencyCode,
            price: effectiveUnitPrice
          }
        },
        elements: {
          FormattedPrice
        }
      });
    // graduated pricing: the price decreases as the quantity increases, and the price is different for each quantity
    case 'graduated':
      return quantityGreaterThanFirstTier ? null : /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "payments.perItem_jsx",
        options: {
          priceProps: {
            currencyCode,
            price: effectiveUnitPrice
          }
        },
        elements: {
          FormattedPrice
        }
      });
    // price is always different per quantity so we never display the unit price
    case 'stairstep':
      return null;
    default:
      return null;
  }
}